
    import 'next/dist/server/node-polyfill-headers'

    export * as handlers from "/Users/xcatliu/work/github/chatgpt-next/app/api/chat/route.ts"
    export const resolvedPagePath = "/Users/xcatliu/work/github/chatgpt-next/app/api/chat/route.ts"

    export { staticGenerationAsyncStorage } from 'next/dist/client/components/static-generation-async-storage'
  
    export * as serverHooks from 'next/dist/client/components/hooks-server-context'
    
    export { staticGenerationBailout } from 'next/dist/client/components/static-generation-bailout'
    
    export * as headerHooks from 'next/dist/client/components/headers'
  
    export { requestAsyncStorage } from 'next/dist/client/components/request-async-storage'
  